import React from "react";

import PlusCircle from "@uui/PlusCircle";

import Button, { ButtonProps } from "@mui/material/Button";
import styled from "@mui/material/styles/styled";

import Stack, { Row, StackProps } from "@rui/Stack";

export const OuterContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1, 0),
  margin: theme.spacing(0, 1.5),
  "&:not(:last-of-type)": {
    borderBottom: "1px solid",
    borderColor: theme.palette.shades.neutral[100],
  },
}));

type InnerContainerProps = StackProps & {
  disabled: boolean;
  selected: boolean;
};

export const InnerContainer = styled<React.FC<InnerContainerProps>>(
  ({ disabled: _d, selected: _s, ...props }) => <Row {...props} />
)(({ disabled, selected, theme }) => ({
  borderRadius: "8px",
  border: "1px solid transparent",
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  padding: theme.spacing(1, 1.5),
  color: theme.palette.shades.neutral[800],
  borderColor: selected ? theme.palette.shades.primary[500] : undefined,
  "&:hover": {
    cursor: "pointer",
  },
  ...(disabled
    ? {
        backgroundColor: theme.palette.transparent.black[4],
        "& .icon__img": {
          filter: "grayscale(1)",
        },
      }
    : {
        "&:hover": {
          cursor: "pointer",
          borderColor: theme.palette.shades.primary[500],
        },
      }),
}));

export const AddButton = styled<React.FC<ButtonProps>>((props) => (
  <Button variant="text" startIcon={<PlusCircle />} {...props}>
    Add
  </Button>
))(({ theme }) => ({
  fontSize: "0.75rem",
  minWidth: 0,
  marginRight: theme.spacing(-0.5),
  "& .MuiButton-startIcon": {
    marginRight: theme.spacing(0.5),
    svg: {
      fontSize: "16px",
    },
  },
}));
